import controller from './controller';
import template from './template.html';

const controllerAs = 'profileCtrl';
const bindings = {
  ngProfileUid: '<',
  labelColumn: '<',
  inputColumn: '<',
  headerColumn: '<',
  ngFieldSet: '<',
  cancelCallback: '&?',
  cancelCallbackArgs: '=',
  successCallback: '&?',
  successCallbackArgs: '='
};

export default {
  template,
  controller,
  controllerAs,
  bindings
};



// WEBPACK FOOTER //
// ./src/app/components/users/profile/index.js